import { Check, Copy, Icon } from "@norican/icons";
import { Button } from "@norican/react";
import { useState } from "react";

import { logger } from "@/lib/logger";

const COPIED_RESET_MS = 2000;

/** A small Copy button for one value on the person card (user ID, email, phone). */
export function CopyValue({ value, label }: { value: string; label: string }) {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    void navigator.clipboard
      .writeText(value)
      .then(() => {
        setCopied(true);
        window.setTimeout(() => setCopied(false), COPIED_RESET_MS);
      })
      .catch((error: unknown) => {
        // Denied in some managed browser profiles: a convenience, so it fails quietly.
        logger.warn("[it-admin] clipboard write refused", error);
      });
  };
  return (
    <Button
      variant="ghost"
      tone="neutral"
      size="sm"
      iconOnly
      aria-label={label}
      title={label}
      onClick={handleCopy}
    >
      <Icon icon={copied ? Check : Copy} size="sm" tone={copied ? "success" : undefined} />
    </Button>
  );
}
